import { useNavigate, useLocation } from "react-router-dom";
import { useFeatureFlagEnabled } from "posthog-js/react";

interface ReferralNavigationButtonProps {
  className?: string;
  children: React.ReactNode;
  disabled?: boolean;
}

export function ReferralNavigationButton({
  className,
  children,
  disabled,
}: ReferralNavigationButtonProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const isNewFlowEnabled = useFeatureFlagEnabled("appeal-hub-referral-flow-v2");

  const handleClick = () => {
    if (disabled) return;

    // Use feature toggle to determine which referral flow to navigate to
    if (isNewFlowEnabled) {
      navigate("/refer");
    } else {
      navigate("/refer-patient");
    }
  };

  const isDisabled =
    disabled ||
    location.pathname === "/refer-patient" ||
    location.pathname === "/refer";

  return (
    <button
      className={className}
      onClick={handleClick}
      type="button"
      disabled={isDisabled}
    >
      {children}
    </button>
  );
}
